export default function omit(obj: Record<string, unknown>, keysToOmit: string[]): Record<string, unknown> {
	const result = { ...obj };
	keysToOmit.forEach((key) => {
		delete result[key];
	});
	return result;
}
